import { render, staticRenderFns } from "./LpuSpecialityList.vue?vue&type=template&id=115f03c2&"
import script from "./LpuSpecialityList.vue?vue&type=script&lang=js&"
export * from "./LpuSpecialityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115f03c2')) {
      api.createRecord('115f03c2', component.options)
    } else {
      api.reload('115f03c2', component.options)
    }
    module.hot.accept("./LpuSpecialityList.vue?vue&type=template&id=115f03c2&", function () {
      api.rerender('115f03c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/LpuSpecialityList/LpuSpecialityList.vue"
export default component.exports